module.exports = "//img1.rrcimg.com/_next/static/src/assets/wh_3cqYr.png";